import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgOutgoingCallUnanswered = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
    <path
      d="m15.177 2.35.984.879c.743.661.863 1.597.36 2.807-.755 1.815-3.585 6.192-9.75 9.891-1.36.957-2.581.741-3.142 0-.374-.494-.74-.967-1.1-1.42-.4-.616-.231-1.188.504-1.715 1.102-.792.75-.513 1.65-1.13.902-.618.894-.48 2.089 0 1.194.48 1.206.897 2.39-.233.789-.753 1.8-1.783 3.033-3.088.463-.434.463-.977 0-1.627-.694-.974-.694-1.349 0-2.417a20.5 20.5 0 0 1 1.428-1.948c.514-.465 1.032-.465 1.554 0zM3.064 0l-.493 5.635m3.064-2.571L0 2.571m6.12 3.378L9.5 9.283m-4.338-.684.718-2.962 3.112-.252"
      fill="#ff3939"
      fillRule="evenodd"
      stroke="#ff3939"
    />
  </svg>
);
const Memo = memo(SvgOutgoingCallUnanswered);
export default Memo;
